import { action, thunk } from 'easy-peasy';

import {getTimezones, setTimezone} from '../services/Timezone';

const TimezoneModel = {
  timezones: ["US/Central"],
  showTimezones: action((state, new_tzs) => {
    state.timezones = new_tzs;
  }),
  getTimezones: thunk(async (actions) => {
    let tzs = await getTimezones();
    actions.showTimezones(tzs);
  }),
  setTimezone: thunk(async (_, payload) => {
    const response = await setTimezone(payload);
    return response;
  }),
}

export default TimezoneModel;
